import * as z from "zod";
import { gql } from "graphql-request";
import { Sys, SysFragment } from "./sys";

export const CountdownTimer = z.object({
  sys: Sys,
  __typename: z.literal("CountdownTimer"),
  timerText: z.string().nullable(),
  timerEndDate: z.string().nullable(),
  timerKind: z.string().nullable(),
});

export type CountdownTimer = z.infer<typeof CountdownTimer>;

export const CountdownTimerFragment = gql`
  fragment CountdownTimerFragment on CountdownTimer {
    sys {
      ...SysFragment
    }
    __typename
    timerText
    timerEndDate
    timerKind
  }

  ${SysFragment}
`;
